import cn from 'classnames';
import { memo, useMemo } from 'react';

import { Accordion, Card, Icon, Space, Typography } from '@sravni/react-design-system';
import { Crown } from '@sravni/react-icons';
import { PAGE_TYPE } from '@sravni/ugc/lib/organizations/constants';

import { BageIcon } from './components';
import { winners } from './data';
import styles from './winner-label.module.scss';

interface IWinnerLalbeProps {
  id: string;
  type: PAGE_TYPE;
  isMobile: boolean;
}

const getCountValue = (count: number) => {
  switch (count) {
    case 3:
      return 'трёх';
    case 4:
      return 'четырёх';
    case 5:
      return 'пяти';
    case 6:
      return 'шести';
    default:
      return `нескольких`;
  }
};

export const WinnerLabel = memo<IWinnerLalbeProps>(({ id, type, isMobile }) => {
  const content = winners[type]?.filter((item) => item.id.toString() === id.toString());

  const renderWinnerLabel = useMemo(() => {
    if (!content?.length) return null;

    if (content.length > 2) {
      return (
        <Card color="green" size={16} className={cn(styles.card, 'h-mb-16')}>
          <Accordion>
            <Accordion.Item
              title="Победитель ежегодной премии Сравни"
              subtitle={`в ${getCountValue(content.length)} номинациях`}
              icon={<BageIcon content={content} />}
            >
              <ul className={styles.list}>
                {content.map((item) => (
                  <li key={`winner-${item.nomination.length}`}>{item.nomination}</li>
                ))}
              </ul>
            </Accordion.Item>
          </Accordion>
        </Card>
      );
    }
    return (
      <div className={'h-mt-16'}>
        {content.map((item, i) => (
          <Card
            color="green"
            size={16}
            key={`winner-${item.nomination.length}`}
            className={i === content.length - 1 ? 'h-mb-16' : 'h-mb-8'}
          >
            <Space size={12} align="center">
              <Icon background="light" variant="primary" size={20} shape="round">
                <Crown color="var(--color-G100)" />
              </Icon>
              <div>
                <Typography.Text size={isMobile ? 12 : 16} strong className="h-mb-2">
                  {item.nomination}
                </Typography.Text>
                <Typography.Text size={12} className="h-color-D60">
                  Победитель ежегодной премии Сравни
                </Typography.Text>
              </div>
            </Space>
          </Card>
        ))}
      </div>
    );
  }, [content, isMobile]);

  return renderWinnerLabel;
});
